module.exports = __webpack_public_path__ + "img/photos-dashboard-icon.8784aa9.png";